import { colors } from 'fitify-ui'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledMention = styled.div`
  display: flex;
  margin: 0 auto;
`
export const StyledMentions = styled.div`
  display: grid;
  align-items: center;
  padding: 40px 24px 44px;
  border: 1px solid ${colors.Gray200};
  border-radius: 24px;
  background: ${colors.White};
  grid-gap: 40px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);

  img {
    width: 100%;
    height: auto;
  }

  ${phone(css`
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    border-radius: 16px;
    grid-row-gap: 27px;

    img {
      width: auto;
      height: 31px;
    }
  `)}
`
